import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { LogoMark, LogoFull } from "@/components/Logo";
import { Field, GoldButton, inputCls } from "@/components/common";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try { await login(email, password); } catch (err) { setError(errMsg(err)); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#FDFBF7]">
      <div className="relative hidden lg:flex flex-col justify-between bg-[#090909] p-14 overflow-hidden">
        <div className="absolute -right-40 -top-40 h-[520px] w-[520px] rounded-full border border-[#C5A059]/25" />
        <div className="absolute -right-24 -top-24 h-[380px] w-[380px] rounded-full border border-[#C5A059]/15" />
        <div className="text-xs uppercase tracking-[0.3em] text-[#C5A059]">Gestionale del centro</div>
        <div className="fade-up">
          <LogoFull className="w-full max-w-md" />
          <p className="mt-6 max-w-sm text-[#CFC6B8] leading-relaxed">Clienti, appuntamenti, operatori e magazzino in un unico luogo, curato come i tuoi trattamenti.</p>
        </div>
        <div className="h-px w-24 bg-[#C5A059]" />
      </div>
      <div className="flex flex-col lg:items-center lg:justify-center lg:px-6 lg:py-16">
        <div className="lg:hidden bg-[#090909]"><LogoFull className="mx-auto w-full max-w-xs" /></div>
        <div className="flex flex-1 items-start lg:items-center justify-center px-6 py-10 lg:p-0 w-full">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6 fade-up" data-testid="login-form">
          
          <div>
            <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#C5A059] mb-2">Area riservata</div>
            <h2 className="font-serif text-4xl text-[#121212]">Bentornata</h2>
          </div>
          <Field label="Email"><input type="email" required className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" /></Field>
          <Field label="Password"><input type="password" required className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" /></Field>
          {error && <div className="rounded-xl border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="login-error">{error}</div>}
          <GoldButton type="submit" disabled={loading} className="w-full py-3" data-testid="login-submit-button">{loading ? "Accesso…" : "Accedi"}</GoldButton>
        </form>
        </div>
      </div>
    </div>
  );
}
